import { base64ToBytes, readUInt32LE, readBigUInt64LE } from './utils.js';
const COMPUTE_BUDGET_INSTRUCTIONS = {
    0: 'RequestUnitsDeprecated',
    1: 'RequestHeapFrame',
    2: 'SetComputeUnitLimit',
    3: 'SetComputeUnitPrice',
    4: 'SetLoadedAccountsDataSizeLimit',
};
export const decodeComputeBudgetInstruction = (ix) => {
    if (ix.programId !== 'ComputeBudget111111111111111111111111111111')
        return undefined;
    if (!ix.data)
        return { name: 'ComputeBudget Instruction' };
    try {
        const buf = base64ToBytes(ix.data);
        const type = readUInt32LE(buf, 0);
        const name = COMPUTE_BUDGET_INSTRUCTIONS[type] ?? `Unknown (${type})`;
        const args = { type };
        if (type === 2 && buf.length >= 5) {
            args.units = readUInt32LE(buf, 1);
        }
        if (type === 3 && buf.length >= 9) {
            args.microLamports = Number(readBigUInt64LE(buf, 1));
        }
        return { name, args };
    }
    catch {
        return { name: 'ComputeBudget Instruction' };
    }
};
//# sourceMappingURL=compute-budget.js.map